import { render, staticRenderFns } from "./sampleCell.vue?vue&type=template&id=5a24da00"
import script from "./sampleCell.vue?vue&type=script&lang=js"
export * from "./sampleCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports